export default "__VITE_ASSET__WNAOvCEj__"